import { replace, type RouteObject } from "react-router"
import { routeTree } from "../../route-tree"
import { lazyLoadComponent } from "../../utils"
import { IS_DEV } from "@/shared/config/env"
import WithTopBarLayout from "@/app/layouts/WithTopBarLayout"

export const rootRoutes: RouteObject[] = [
  {
    path: routeTree.root.segment,
    Component: WithTopBarLayout,
    children: [
      {
        index: true,
        // The app has one working page, so the root sends the user straight to it.
        loader: () => replace(routeTree.export.path()),
      },
      {
        path: routeTree.export.segment,
        lazy: lazyLoadComponent(() => import("@/pages/ExportPage")),
      },
      {
        path: routeTree.auth.segment,
        lazy: lazyLoadComponent(() => import("@/pages/AuthPage")),
      },
    ],
  },
  {
    path: routeTree.error.segment,
    lazy: lazyLoadComponent(() => import("@/pages/ErrorPage")),
  },
  {
    path: routeTree.notFound.segment,
    lazy: lazyLoadComponent(() => import("@/pages/NotFoundPage")),
  },
]

if (IS_DEV) {
  rootRoutes.push({
    path: routeTree.devPlayground.segment,
    lazy: lazyLoadComponent(() => import("@/pages/DevPlaygroundPage")),
  })
}
